(function(){
    "use strict";
    
    angular
        .module("app")
        .component("purchaseOrderShipment", { // purchase-order-shipment
            bindings: {
                shipment: "<"  
            },
            templateUrl: "src/app/purchaseOrder/purchaseOrderShipment.html",
            controller: controller
        });

    function controller($window, session, reportService) {
        const $ctrl = this;
        $ctrl.session = session;

        $ctrl.packListClicked = orderId => {
            //$window.ga("send", "event", "PackListReport", "packListReportClicked");
            reportService.getPackListRpt(orderId);
        };

        $ctrl.invoiceClicked = orderId => {
            //$window.ga("send", "event", "InvoiceReport", "invoiceReportClicked");
            reportService.getInvoiceRpt(orderId);
        };
    }
    controller.$inject = ["$window", "sessionService", "reportService"];
    
})()